import * as ko from 'knockout';

export class PartnerDiamentComponent {
    index: ko.Observable<number>;
    timer: any;
    numberOfItems = 3;

    executeTimer() {
        this.timer = setTimeout(() => {
            this.index(this.index() % this.numberOfItems + 1);
            this.executeTimer();
        }, 5000);
    }

    constructor() {
        this.index = ko.observable(1);
        this.executeTimer();
    }

    isCurrentIndex(index: any) {
        return this.index() === index;
    }

    moveLeft() {
        clearTimeout(this.timer);
        let newIndex = (this.index() - 1) % this.numberOfItems;
        if (newIndex === 0) {
            newIndex = this.numberOfItems;
        }

        this.index(newIndex);
    }

    moveRight() {
        clearTimeout(this.timer);
        this.index(this.index() % this.numberOfItems + 1);
    }
}
